import { render } from "./TidligereArbejde.vue?vue&type=template&id=172e6d7f&scoped=true"
import script from "./TidligereArbejde.vue?vue&type=script&lang=js"
export * from "./TidligereArbejde.vue?vue&type=script&lang=js"

import "./TidligereArbejde.vue?vue&type=style&index=0&id=172e6d7f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-172e6d7f"]])

export default __exports__